import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "UI/Form/Select";
import { TextInput } from "UI/Form/TextInput";
import { Grid } from "UI/Grid";
import { PageTemplatesQueryParams } from "api/baseAPI/invoicing";
import { useLazyGetPointServicesQuery } from "api/baseAPI/pointServices";
import { TableFilter } from "components/table/TableFilter";
import { useSelectedPointManager } from "hooks/useSelectedEntity";
import { useFilterMakerResult } from "utils/filterMaker";
import { handleChangeNumber, numberForInput } from "utils/numbers";

export const PageTemplatesFilters = ({
  filters,
}: {
  filters: useFilterMakerResult<PageTemplatesQueryParams>;
}) => {
  const { t } = useTranslation();
  const { values, setValue, errors } = filters;

  const selectedPointManager = useSelectedPointManager();

  const [pointServices, pointServicesMeta] = useLazyGetPointServicesQuery();

  useEffect(() => {
    if (selectedPointManager.point?.id) {
      pointServices({
        page: "1",
        page_size: "100",
        search: "",
        point: selectedPointManager.point?.id,
      });
    }
  }, [selectedPointManager.point?.id]);

  const getServices = useMemo(() => {
    const { data } = pointServicesMeta;
    if (data && data?.results?.length) {
      const services = Array.from(
        new Set(
          data?.results?.map((item) => ({
            value: String(item.service?.id),
            label: `${item.service?.id} | ${item.service?.name}`,
          }))
        )
      );
      return services;
    }
    return [];
  }, [pointServicesMeta?.data]);

  return (
    <TableFilter
      onSubmit={filters.handleSubmit}
      onReset={filters.handleReset}
      disabledReset={filters.disabledReset}
      disableSubmit={!!errors}
      widthBox="60%"
    >
      <Grid container mt={12} hSpace={24} vSpace={24} smHSpace={8}>
        <Grid item sm={12} md={6}>
          <TextInput
            size="small"
            label={t("ID Шаблона")}
            placeholder={t("Предварительно заполнить")}
            value={values.id}
            onChange={(value) => setValue("id", value)}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput
            size="small"
            label={t("Название")}
            placeholder={t("Предварительно заполнить")}
            value={values.title__icontains}
            onChange={(value) => setValue("title__icontains", value)}
          />
        </Grid>
        <Grid item sm={12}>
          <Select
            value={values.service}
            onChange={(value) => setValue("service", value)}
            label={t("Услуга")}
            placeholder={t("Выберите")}
            size="small"
            options={getServices}
          />
        </Grid>
        <Grid item sm={6}>
          <TextInput
            size="small"
            label={t("Сумма от")}
            placeholder={t("Предварительно заполнить")}
            value={numberForInput(values.fixed_amount__gte)}
            onChange={(value) =>
              setValue(
                "fixed_amount__gte",
                handleChangeNumber(value.replace(/[^0-9.]/g, ""))
              )
            }
          />
        </Grid>
        <Grid item sm={6}>
          <TextInput
            size="small"
            label={t("Сумма до")}
            placeholder={t("Предварительно заполнить")}
            value={numberForInput(values.fixed_amount__lte)}
            onChange={(value) =>
              setValue(
                "fixed_amount__lte",
                handleChangeNumber(value.replace(/[^0-9.]/g, ""))
              )
            }
          />
        </Grid>
      </Grid>
    </TableFilter>
  );
}
